import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Fragment } from "react";
import PortalSearchTable from "../../common/table/PortalSearchTable";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
  AlertSpg,
  OptionTableCell,
  SecurityGuard,
  SecurityRole,
  separatePath,
  TableButton,
} from "@duosoftbg/nacid-components";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { openModal } from "../../../../store/redux/slice/ComponentsControl/nationalUniversityControl";
import NationalUniversityLogoTableCell from "./NationalUniversityLogoTableCell";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.name",
  },
  {
    id: "settlementName",
    label: "l.table.head.settlementName",
  },
  {
    id: "address",
    label: "l.table.head.address",
  },
  {
    id: "zipCode",
    label: "l.table.head.zipcode",
  },
  {
    id: "website",
    label: "l.table.head.website",
  },
  {
    id: "isActive",
    label: "l.table.head.active",
    sortable: false,
  },
  {
    id: "logoRelativePath",
    label: "l.table.head.logo",
    sortable: false,
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const NationalUniversityDataListTable = ({ total, records, blockTable, onPageOrOrderChange, group }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <Fragment>
      {total > 0 && (
        <PortalSearchTable
          group={group}
          headCells={headCells}
          total={total}
          blockTable={blockTable}
          onPageOrOrderChange={onPageOrOrderChange}
        >
          <TableBody>
            {records.map((row, index) => (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.settlement.fullSettlementName}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.zipCode}</TableCell>
                <TableCell>{row.website}</TableCell>
                <TableCell>{row.isActive ? t("l.yes") : t("l.no")}</TableCell>
                <NationalUniversityLogoTableCell
                  separatedPath={separatePath(row.logoRelativePath)}
                ></NationalUniversityLogoTableCell>
                <OptionTableCell>
                  <SecurityGuard checkForRoles={[SecurityRole.AcNationalUniversitiesEdit]}>
                    <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, "edit")} />
                    <TableButton type={"remove"} onClick={() => handleOpenModal(row.id, "delete")} />
                  </SecurityGuard>
                </OptionTableCell>
              </TableRow>
            ))}
          </TableBody>
        </PortalSearchTable>
      )}
      {!(total > 0) && (
        <AlertSpg mt={10} mb={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      )}
      <SecurityGuard checkForRoles={[SecurityRole.AcNationalUniversitiesEdit]}>
        <Button
          startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
          size={"medium"}
          type={"button"}
          variant="contained"
          color="secondary"
          onClick={() => handleOpenModal("", "edit")}
        >
          {t("l.btn.create")}
        </Button>
      </SecurityGuard>
    </Fragment>
  );
};

export default NationalUniversityDataListTable;
